import React, { useState } from "react";
import { transactionTimeStamp } from "../../../utils";
import { userDetails } from "../../../utils";
import ModalDialog from "../../layouts/ModalDialog";
import EditPersonalInformation from "./EditPersonalInformation";
const Detail = ({ label, value }) => (
  <div>
    <p className="text-xs font-medium tracking-wider text-vcm-dark-gray">
      {label}
    </p>
    <p className="mt-2 text-sm font-medium text-gray-900">
      {value || <span className='text-gray-400'>Not provided</span>}
    </p>
  </div>
);

const Section = ({ title, children, currentStaffLoggedIn, triggerUpdate }) => (
  <section className="border-b border-gray-100 px-2 py-6 last:border-0">
    <div className="">
      <div className="w-full flex items-start justify-between gap-x-3">
        <h2 className="font-space-grotesk text-base font-semibold text-gray-900">
          {title}
        </h2>
        {currentStaffLoggedIn && title==="Personal information" && <button onClick={triggerUpdate} className="text-xs font-semibold font-space-grotesk text-gray-600 rounded-lg bg-gray-200 hover:bg-gray-300 transition duration-200 px-4 py-3">Edit Personal Information</button>}
      </div>

      <div className="mt-5 grid grid-cols-1 gap-x-6 gap-y-6 sm:grid-cols-2 xl:grid-cols-3">
        {children}
      </div>
    </div>
  </section>
);

const StaffDetails = ({ staff, reload }) => {
  const currentStaffLoggedIn = staff?._id === userDetails()?.staffMemberProfile;
  const [updatingInfo, setUpdatingInfo] = useState(false);
  return (
    <>
      <div className="overflow-hidden">
        <Section title="Personal information" currentStaffLoggedIn={currentStaffLoggedIn} triggerUpdate={()=>{setUpdatingInfo(true)}}>
          <Detail label="First name" value={staff?.firstName} />
          <Detail label="Other name(s)" value={staff?.otherNames} />
          <Detail label="Last name" value={staff?.lastName} />
          <Detail
            label="Date of birth"
            value={staff?.dob ? transactionTimeStamp(staff.dob).date : null}
          />
          <Detail label="Blood group" value={staff?.bloodGroup} />
          <Detail
            label="Marital status"
            value={staff?.maritalStatus?.toLowerCase()}
          />
          {/* <Detail label="Dependants" value={staff?.dependants ?? 0} /> */}
        </Section>
        <Section title="Contact information" currentStaffLoggedIn={currentStaffLoggedIn}>
          <Detail label="Email address" value={staff?.email} />
          <Detail label="Phone number" value={staff?.phone} />
          <Detail label="Alternate phone" value={staff?.altPhone} />
        </Section>
        <Section title="Home address" currentStaffLoggedIn={currentStaffLoggedIn}>
          <Detail label="Street address" value={staff?.address?.address} />
          <Detail label="City" value={staff?.address?.city} />
          <Detail label="State" value={staff?.address?.state} />
        </Section>
        <Section title="Origin" currentStaffLoggedIn={currentStaffLoggedIn}>
          <Detail label="Country" value={staff?.origin?.country} />
          <Detail label="State" value={staff?.origin?.state} />
          <Detail label="LGA" value={staff?.origin?.lga} />
        </Section>
      </div>

      <ModalDialog
        shown={updatingInfo} 
        closeFunction={()=>{setUpdatingInfo(false)}} 
        actionFunction={()=>{}} 
        actionFunctionLabel={``}
        dialogTitle='Update Personal Information'
        maxWidthClass='max-w-4xl'
        hideActions={true}
      >
          <EditPersonalInformation 
            staff={staff}
            closeFunction={()=>{setUpdatingInfo(false)}} 
            reload={reload} 
          />
      </ModalDialog>

    </>
  );
};
export default StaffDetails;